import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { LocationInfo } from '../common/googlemap.service';
import $ from 'jquery';
import { CommonService } from "../app.service";


/** モーダルコンポーネント */
@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html'
  })
export class ModalComponent implements OnInit {

    /** モーダルディレクティブを保持する */
    @Input()
    modal: any;

    @Input()
    pagename: string;

    @Input()
    locationList: LocationInfo[];

    @Input()
    carAlertList: any[];

    /** モーダルが閉じられた時のイベント */
    @Output()
    modalclose = new EventEmitter();

    @Output()
    selectAddress = new EventEmitter<LocationInfo>();

    constructor(
        public commonService: CommonService
    ) { }

    ngOnInit() {
        var pname = this.pagename;
        $(function() {
            $('#confirmModal').on('show.bs.modal', function (event) {
                var button = $(event.relatedTarget);
                var recipient = button.data('whatever');
                var modal = $(this);
                var name = $('#name').val();
                if (pname=='車両') {
                    name = $('#car_no').val();
                }
                else if (pname=='貨物') {
                    name = $('#cargo_id').val() ? ("「"+$('#cargo_id').val()+"」") : "";
                }
                else if (pname=='お知らせ') {
                    name = $('#title').val();
                }
                modal.find('.modal-title').text(pname + recipient + '確認');
                modal.find('.modal-body').html(pname+(!!name ? '【'+name+'】' : '')+'を'+recipient+'します。<br>よろしいですか？');
                modal.find('#confirmModal_btn').text(recipient);
                if (recipient=="削除") {
                    modal.find('#confirmModal_btn').removeClass('btn-primary');
                    modal.find('#confirmModal_btn').addClass('btn-danger');
                } else {
                    modal.find('#confirmModal_btn').removeClass('btn-danger');
                    modal.find('#confirmModal_btn').addClass('btn-primary');
                }
            });
        });
    }

    /** 入力値を保持しておくプロパティ */
    //text: string = '';

    /** OK ボタン押下時は (close) イベントを発火させつつモーダルを閉じる */
    onOk(): void {
        this.modalclose.emit();
        $('#confirmModal').modal('hide');
    }
  
    /** No ボタンや「×」ボタンなど : ただモーダルを閉じるだけ */
    closeModal(): void {
        this.modal.hide();
    }

    onSelect(location: LocationInfo): void {
        this.selectAddress.emit(location);
        $('#addressSearchModal').modal('hide');
    }

}



// WEBPACK FOOTER //
// ./src/app/common/modal.component.ts